import { render } from "./404Page.vue?vue&type=template&id=23a45338"
const script = {}

import exportComponent from "C:\\Users\\honza\\Local Sites\\cestakzamestnani\\app\\public\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__